import { Coordinates } from '../core/api/general/general.types';
import { storage } from './services/storageServices';

export class Store<T> {
  private readonly key: string;

  constructor(key: string) {
    this.key = key;
  }

  public Save(data: T) {
    storage.setItem<T>(this.key, data);
  }

  public Load(): T | null {
    try {
      const object = storage.getItem<T>(this.key);
      if (!object) {
        return null;
      }
      return object;
    } catch (syntaxError) {
      console.warn('Syntax error loading', this.key, syntaxError);
      return null;
    }
  }
}

export const LocationStore = new Store<Coordinates>('flipdish-location');

try {
  // Delete old basket key - 2016-11-07
  localStorage.removeItem('flipdish-basket-item-store');
} catch (e) {}
